import axios from 'axios';
export const FETCH_TICKET_REQUEST = 'FETCH_TICKET_REQUEST';
export const FETCH_TICKET_SUCCESS = 'FETCH_TICKET_SUCCESS';
export const FETCH_TICKET_FAILURE = 'FETCH_TICKET_FAILURE';
const base_url = process.env.REACT_APP_API_URL_ADMIN;


export const fetchDSAdminTicket = (gameId, drawId) => async (dispatch) => {
  dispatch({ type: FETCH_TICKET_REQUEST });

  try {
    console.log("fetchDSAdminTicket",drawId)
     const response = await axios.post(`${base_url}`, {
    apiName: "ds_tkt_details", 
    command: "DS_Ticket",
    gameId: gameId, 
    drawId : drawId
    });
    console.log('fetchDSAdminTicket res ',response.data.data)
    dispatch({ type: FETCH_TICKET_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({
      type: FETCH_TICKET_FAILURE,
      payload: error.message || 'Something went wrong'
    });
  }
};